import { Component, Input } from '@angular/core';
import { Tile } from '@app/models/content';
import {TileContext, TileFormat} from "@app/shared/enums";

@Component({
  selector: 'app-tile-article',
  templateUrl: './tile-article.component.html',
  styleUrls: ['./tile-article.component.scss']
})
export class TileArticleComponent {

  @Input() tile: Tile;
  @Input() format: TileFormat;
  @Input() context: TileContext;

  constructor() { }
}
